import { userAudioRecordingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AUDIO_RECORDINGS_ACTION_TYPE = createNamedActions('audioRecordings', {
  CREATE_AUDIO_RECORDING: 'CREATE_AUDIO_RECORDING',
  GET_AUDIO_RECORDINGS_LIST: 'GET_AUDIO_RECORDINGS_LIST',
  GET_AUDIO_RECORDING_URL: 'GET_AUDIO_RECORDING_URL',
  DELETE_AUDIO_RECORDING: 'DELETE_AUDIO_RECORDING',
  EDIT_AUDIO_RECORDING_CONTENT: 'EDIT_AUDIO_RECORDING_CONTENT',
  EDIT_AUDIO_RECORDING: 'EDIT_AUDIO_RECORDING',
  SET_IS_UPLOADING_AUDIO_RECORDING: 'SET_IS_UPLOADING_AUDIO_RECORDING',
});

const audioRecordingsSchema = new schema.Entity('data', {}, { idAttribute: 'audioRecordingId' });

export const getAudioRecordingsListAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userAudioRecordingApi.getAudioRecording(params);

  return dispatch({
    type: AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDINGS_LIST,
    payload: normalize(data, [audioRecordingsSchema]).entities.data,
  });
});

export const getAudioRecordingUrlByAudioRecordingIdAction = catchAsyncActionError(
  ({ audioRecordingId }) =>
    async dispatch => {
      const { data: url } = await userAudioRecordingApi.getAudioRecordingUrl({ audioRecordingId });

      return dispatch({
        type: AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDING_URL,
        payload: { url, audioRecordingId },
      });
    },
);

export const createAudioRecordingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userAudioRecordingApi.createAudioRecording(params);

  return dispatch({
    type: AUDIO_RECORDINGS_ACTION_TYPE.CREATE_AUDIO_RECORDING,
    payload: data,
  });
});

export const editAudioRecordingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userAudioRecordingApi.editAudioRecording(params);

  return dispatch({
    type: AUDIO_RECORDINGS_ACTION_TYPE.EDIT_AUDIO_RECORDING,
    payload: data,
  });
});

export const editAudioRecordingsContentAction = catchAsyncActionError(
  ({ url, ...params }) =>
    async dispatch => {
      const { data } = await userAudioRecordingApi.editAudioRecordingContent(params);

      return dispatch({
        type: AUDIO_RECORDINGS_ACTION_TYPE.EDIT_AUDIO_RECORDING_CONTENT,
        payload: { audioRecordingId: data.audioRecordingId, url },
      });
    },
);

export const deleteAudioRecordingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userAudioRecordingApi.deleteAudioRecording(params);

  return dispatch({
    type: AUDIO_RECORDINGS_ACTION_TYPE.DELETE_AUDIO_RECORDING,
    payload: data,
    meta: params,
  });
});

export const setIsUploadingAudioRecordingAction = isUploading => ({
  type: AUDIO_RECORDINGS_ACTION_TYPE.SET_IS_UPLOADING_AUDIO_RECORDING,
  payload: isUploading,
});
